import React, { useState, useEffect, useRef } from "react";
import {
  Container,
  Typography,
  Grid,
  Card,
  CardContent,
  CardMedia,
  Box,
  Button,
  TextField,
  Link,
  IconButton,
} from "@mui/material";
import axios from "axios";
import {
  IMG_DAINA_BLACK_WHITE as HoodieBlack1,
  IMG_DAINA_HOODIE_BLACK_2 as HoodieBlack2,
  IMG_DAINA_HOODIE_BLACK_3 as HoodieBlack3,
  IMG_DAINA_HOODIE_SMALL_LOGO as HoodieBlackSmallLogo1,
  IMG_DAINA_HOODIE_SMALL_LOGO_2 as HoodieBlackSmallLogo2,
  IMG_DAINA_HOODIE_BLACK_3 as HoodieBlackSmallLogo3,
  IMG_BEIGE_HOODIE_1 as HoodieWhite1,
  IMG_BEIGE_HOODIE_2 as HoodieWhite2,
  IMG_HOODIE_BLUE_SMALL_LOGO_01 as HoodieBlue1,
  IMG_HOODIE_BLUE_2 as HoodieBlue2,
  IMG_DAINA_PINK_HOODIE_NEW as HoodiePink1,
  IMG_DAINA_HOODIE_PINK_GIRL as HoodiePink2,
  IMG_DAINA_HOODIE_PINK_OLD_LADY as HoodiePink3,
  IMG_HOODIE_PINK_BACKGROUND as HoodiePink4,
  IMG_DAINA_HOODIE_BACK_BALI as BaliHoodie,
  IMG_DAINA_HOODIE_BACK_BANGKOK as BangkokHoodie,
  IMG_DAINA_HOODIE_BACK_CANADA as CanadaHoodie,
  IMG_SWEATSHIRT_BLACK_MAIN as SweatshirtBlackMain,
  IMG_SWEATSHIRT_BLACK as SweatshirtBlack1,
  IMG_HOODIE_BLACK_RED_MAIN as HoodieBlackRedMain,
  IMG_HOODIE_BLACK_RED_1 as HoodieBlackRed1,
  IMG_DAINA_HOODIE_BLACK_3 as HoodieBlackRed2,
  IMG_HOODIE_BEIGE_RED_1 as HoodieWhiteRedMain,
  IMG_HOODIE_WHITE_RED_1 as HoodieWhiteRed1,
  IMG_DAINA_HOODIE_HANG as BottomImage2,
  IMG_DAINA_TSHIRT1 as TShirtWhite1,
  IMG_DAINA_TSHIRT2 as TShirtWhite2,
  IMG_DAINA_TSHIRT3 as TShirtBlack1,
  IMG_DAINA_TSHIRT4 as TShirtBlack2,
  IMG_TSHIRT_BEIGE_BACK,
  IMG_TSHIRT_BEIGE_LOGO_BLACK_BOY,
  IMG_TSHIRT_BEIGE_LOGO_BLACK_GIRL,
  IMG_TSHIRT_BEIGE_LOGO_BLACK,
  IMG_TSHIRT_BEIGE_LOGO_RED_BOY,
  IMG_TSHIRT_BEIGE_LOGO_RED_GIRL1,
  IMG_TSHIRT_BEIGE_LOGO_RED_GIRL2,
  IMG_TSHIRT_BEIGE_LOGO_RED_GIRL3,
  IMG_TSHIRT_BEIGE_LOGO_RED,
  IMG_TSHIRT_BEIGE_LOGO_WHITE_BOY,
  IMG_TSHIRT_BEIGE_LOGO_WHITE_GIRL,
  IMG_TSHIRT_BEIGE_LOGO_WHITE,
  IMG_TSHIRT_BEIGE_WITHOUT_LOGO_BOY,
  IMG_TSHIRT_BEIGE_WITHOUT_LOGO_GIRL,
  IMG_TSHIRT_BEIGE_WITHOUT,
} from "./imageConfig";
import {
  IMG_ETHNIC_IMAGE_1,
  IMG_ETHNIC_IMAGE_2,
  IMG_ETHNIC_IMAGE_3,
  IMG_ETHNIC_IMAGE_4,
} from "./imageConfig";
// import CasualChic from "./images/Casual Chic with DAINA T-shirt.png";
import { useNavigate } from "react-router-dom";
import { supabase } from "../SupabaseClient";
import Reviews from "./Reviews";
import FeaturedEdits from "./FeaturedEdits";
import ShopTheLook from "./ShopTheLook";// Default country (India)
// const defaultCountry = { code: "IN", name: "India", domain: "in" };

// ImageSlider component remains the same
const ImageSlider = ({ images }) => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [hovered, setHovered] = useState(false);

  // Only proceed if there are multiple images
  const hasMultipleImages = images.length > 1;

  return (
    <Box
      sx={{
        position: "relative",
        width: "100%",
        height: { xs: "330px", md: "620px" },
        overflow: "hidden",
        backgroundColor: "#f9f9f9",
      }}
      onMouseEnter={() => hasMultipleImages && setHovered(true)}
      onMouseLeave={() => hasMultipleImages && setHovered(false)}
    >
      {/* Main Image (always visible) */}
      <CardMedia
        component="img"
        image={images[currentImageIndex]}
        alt={`Product ${currentImageIndex + 1}`}
        sx={{
          width: "100%",
          height: "100%",
          objectFit: "cover",
          p: 0,
          position: "absolute",
          top: 0,
          left: 0,
          opacity: hovered ? 0 : 1,
          transition: "opacity 0.3s ease",
        }}
      />

      {/* Hover Image (only visible when hovered) */}
      {hasMultipleImages && (
        <CardMedia
          component="img"
          image={images[(currentImageIndex + 1) % images.length]}
          alt={`Product ${((currentImageIndex + 1) % images.length) + 1}`}
          sx={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            p: 0,
            position: "absolute",
            top: 0,
            left: 0,
            opacity: hovered ? 1 : 0,
            transition: "opacity 0.3s ease",
          }}
        />
      )}
    </Box>
  );
};

// Product data
const hoodieProducts = [
  {
    id: 29,
    title: "DAINA Hoodie | Black Red",
    images: [HoodieBlackRedMain, HoodieBlackRed1, HoodieBlackRed2],
    prices: {
      US: "$99.00",
      CA: "CAD $99.00",
      IN: "₹4,499.00",
      EU: "€95.00",
      GB: "£85.00",
      AU: "$145.00",
      default: "$99.00",
    },
    asin: "B0F7RXKFX8",
    color: "Black",
    category: "hoodie",
    isComingSoon: true, // ✅ Add this
    preOrder: false,
    isSoldOut: false,
    swatches: ["#440000", "#000", "#777"]
  },
  {
    id: 30,
    title: "DAINA Hoodie | Tonal Cream Red",
    images: [HoodieWhiteRedMain, HoodieWhiteRed1],
    prices: {
      US: "$99.00",
      CA: "CAD $99.00",
      IN: "₹4,499.00",
      EU: "€95.00",
      GB: "£85.00",
      AU: "$145.00",
      default: "$99.00",
    },
    asin: "B0F7RV495L",
    color: "Tonal",
    category: "hoodie",
    preOrder: true,
    isSoldOut: false,
    swatches: ["#440000", "#000", "#777"]
  },
  {
    id: 31,
    title: "DAINA Hoodie | Black White",
    images: [
      HoodieBlackSmallLogo1,
      HoodieBlackSmallLogo2,
      HoodieBlackSmallLogo3,
    ],
    prices: {
      US: "$99.00",
      CA: "CAD $99.00",
      IN: "₹4,499.00",
      EU: "€95.00",
      GB: "£85.00",
      AU: "$145.00",
      default: "$99.00",
    },
    asin: "B0F7RV495L",
    color: "Black",
    category: "hoodie",
    isComingSoon: true, // ✅ Add this
    preOrder: false,
    isSoldOut: false,
    swatches: ["#440000", "#000", "#777"]
  },
  {
    id: 1,
    title: "DAINA Hoodie | Black White",
    images: [HoodieBlack1, HoodieBlack2, HoodieBlack3],
    prices: {
      US: "$99.00",
      CA: "CAD $99.00",
      IN: "₹4,499.00",
      EU: "€95.00",
      GB: "£85.00",
      AU: "$145.00",
      default: "$99.00",
    },
    asin: "B0F7RXKFX8",
    color: "Black",
    category: "hoodie",
    isComingSoon: true, // ✅ Add this
    preOrder: false,
    isSoldOut: false,
    swatches: ["#440000", "#000", "#777"]
  },
  {
    id: 2,
    title: "DAINA Hoodie | Tonal Cream",
    images: [HoodieWhite1, HoodieWhite2],
    prices: {
      US: "$99.00",
      CA: "CAD $99.00",
      IN: "₹4,499.00",
      EU: "€95.00",
      GB: "£85.00",
      AU: "$145.00",
      default: "$99.00",
    },
    asin: "B0F7RV495L",
    color: "Tonal",
    category: "hoodie",
    preOrder: true,
    isSoldOut: false,
    swatches: ["#440000", "#000", "#777"]
  },
  /*
  {
    id: 4,
    title: "DAINA Sweatshirt | Black Red",
    images: [SweatshirtBlackMain, SweatshirtBlack1],
    prices: {
      US: "$99.00",
      CA: "CAD $99.00",
      IN: "₹4,499.00",
      EU: "€95.00",
      GB: "£85.00",
      AU: "$145.00",
      default: "$99.00",
    },
    asin: "B0F7RV495L",
    color: "Black",
    category: "hoodie",
    isComingSoon: true, // ✅ Add this
    preOrder: false,
    isSoldOut: false,
    swatches: ["#440000", "#000", "#777"]
  },
  */
  /*
  {
    id: 5,
    title: "DAINA Hoodie | Black | Bangkok",
    images: [BangkokHoodie,HoodieBlackSmallLogo1, HoodieBlackSmallLogo2],
    prices: {
      US: "$99.00",
      CA: "CAD $99.00",
      IN: "₹4,499.00",
      EU: "€95.00",
      GB: "£85.00",
      AU: "$145.00",
      default: "$99.00",
    },
    asin: "B0F7RV495L",
    color: "Black",
    category: "hoodie",
    isComingSoon: true, // ✅ Add this
    preOrder: false,
    isSoldOut: false,
    swatches: ["#440000", "#000", "#777"]
  },
  {
    id: 6,
    title: "DAINA Hoodie | Black | Canada",
    images: [CanadaHoodie,HoodieBlackSmallLogo1, HoodieBlackSmallLogo2],
    prices: {
      US: "$99.00",
      CA: "CAD $99.00",
      IN: "₹4,499.00",
      EU: "€95.00",
      GB: "£85.00",
      AU: "$145.00",
      default: "$99.00",
    },
    asin: "B0F7RV495L",
    color: "Black",
    category: "hoodie",
    isComingSoon: true, // ✅ Add this
    preOrder: false,
    isSoldOut: false,
    swatches: ["#440000", "#000", "#777"]
  },
  */
  {
    id: 7,
    title: "DAINA Hoodie | Pink",
    images: [HoodiePink1, HoodiePink2, HoodiePink3, HoodiePink4],
    prices: {
      US: "$99.00",
      CA: "CAD $120.00",
      IN: "₹4,499.00",
      EU: "€95.00",
      GB: "£85.00",
      AU: "$145.00",
      default: "$99.00",
    },
    asin: "B0F7RV495L",
    color: "Pink",
    category: "hoodie",
    isSoldOut: true,
    isComingSoon: true, // ✅ Add this
    preOrder: false,
    swatches: ["#ffc0cb", "#000", "#777"]
  },
  {
    id: 8,
    title: "DAINA Hoodie | Navy White",
    images: [HoodieBlue1],
    prices: {
      US: "$99.00",
      CA: "CAD $120.00",
      IN: "₹4,499.00",
      EU: "€95.00",
      GB: "£85.00",
      AU: "$145.00",
      default: "$99.00",
    },
    asin: "B0F7RV495L",
    color: "Navy",
    category: "hoodie",
    preOrder: true,
    isSoldOut: true,
  },
  /*
  {
    id: 9,
    title: "DAINA Hoodie | Black White",
    images: [HoodieBlack1, HoodieBlack2, HoodieBlack3],
    prices: {
      US: "$99.00",
      CA: "CAD $120.00",
      IN: "₹4,499.00",
      EU: "€95.00",
      GB: "£85.00",
      AU: "$145.00",
      default: "$99.00",
    },
    asin: "B0F7RV495L",
    color: "Black",
    category: "hoodie",
    preOrder: true,
    isSoldOut: false,
    swatches: ["#440000", "#000", "#777"]
  },
  */
];

const tshirtProducts = [
  {
    id: 101,
    title: "DAINA T-Shirt | Beige | Logo Red",
    images: [IMG_TSHIRT_BEIGE_LOGO_RED, IMG_TSHIRT_BEIGE_LOGO_RED_GIRL1, IMG_TSHIRT_BEIGE_LOGO_RED_GIRL2, IMG_TSHIRT_BEIGE_LOGO_RED_GIRL3, IMG_TSHIRT_BEIGE_LOGO_RED_BOY, IMG_TSHIRT_BEIGE_BACK],
    prices: {
      US: "$25.00",
      CA: "CAD $35.00",
      IN: "₹1,999.00",
      EU: "€25.00",
      GB: "£20.00",
      AU: "$39.00",
      default: "$25.00",
    },
    color: "Beige",
    category: "t-shirt",
    isComingSoon: false,
    isSoldOut: false,
    shipping: "Free shipping worldwide",
    swatches: ["#f5f5dc", "#ff0000", "#000", "#fff"]
  },
  {
    id: 102,
    title: "DAINA T-Shirt | Beige | Logo Black",
    images: [IMG_TSHIRT_BEIGE_LOGO_BLACK, IMG_TSHIRT_BEIGE_LOGO_BLACK_GIRL, IMG_TSHIRT_BEIGE_LOGO_BLACK_BOY, IMG_TSHIRT_BEIGE_BACK],
    prices: {
      US: "$25.00",
      CA: "CAD $35.00",
      IN: "₹1,999.00",
      EU: "€25.00",
      GB: "£20.00",
      AU: "$39.00",
      default: "$25.00",
    },
    color: "Beige",
    category: "t-shirt",
    isComingSoon: false,
    isSoldOut: false,
    shipping: "Free shipping worldwide",
    swatches: ["#f5f5dc", "#ff0000", "#000", "#fff"]
  },
  {
    id: 103,
    title: "DAINA T-Shirt | Beige | Logo White",
    images: [IMG_TSHIRT_BEIGE_LOGO_WHITE, IMG_TSHIRT_BEIGE_LOGO_WHITE_GIRL, IMG_TSHIRT_BEIGE_LOGO_WHITE_BOY, IMG_TSHIRT_BEIGE_BACK],
    prices: {
      US: "$25.00",
      CA: "CAD $35.00",
      IN: "₹1,999.00",
      EU: "€25.00",
      GB: "£20.00",
      AU: "$39.00",
      default: "$25.00",
    },
    color: "Beige",
    category: "t-shirt",
    isComingSoon: false,
    isSoldOut: false,
    shipping: "Free shipping worldwide",
    swatches: ["#f5f5dc", "#ff0000", "#000", "#fff"]
  },
  {
    id: 104,
    title: "DAINA T-Shirt | Beige | Clean",
    images: [IMG_TSHIRT_BEIGE_WITHOUT, IMG_TSHIRT_BEIGE_WITHOUT_LOGO_GIRL, IMG_TSHIRT_BEIGE_WITHOUT_LOGO_BOY, IMG_TSHIRT_BEIGE_BACK],
    prices: {
      US: "$25.00",
      CA: "CAD $35.00",
      IN: "₹1,999.00",
      EU: "€25.00",
      GB: "£20.00",
      AU: "$39.00",
      default: "$25.00",
    },
    color: "Beige",
    category: "t-shirt",
    isComingSoon: false,
    isSoldOut: false,
    shipping: "Free shipping worldwide",
    swatches: ["#f5f5dc", "#ff0000", "#000", "#fff"]
  }
];

export { hoodieProducts, tshirtProducts, ethnicWearProducts };

const ethnicWearProducts = [
  {
    id: 201,
    title: "DAINA Kurta Set | Ivory Block Print",
    images: [IMG_ETHNIC_IMAGE_1, IMG_ETHNIC_IMAGE_2],
    prices: { default: "Sample look" },
    color: "Ivory",
    category: "ethnic-wear",
    isSample: true,
    swatches: ["#eee5d8", "#b66a4b"],
  },
  {
    id: 202,
    title: "DAINA Anarkali Suit | Garden Green",
    images: [IMG_ETHNIC_IMAGE_2, IMG_ETHNIC_IMAGE_3],
    prices: { default: "Sample look" },
    color: "Green",
    category: "ethnic-wear",
    isSample: true,
    swatches: ["#465447", "#d7c29b"],
  },
  {
    id: 203,
    title: "DAINA Sharara Set | Rose Embroidery",
    images: [IMG_ETHNIC_IMAGE_3, IMG_ETHNIC_IMAGE_4],
    prices: { default: "Sample look" },
    color: "Rose",
    category: "ethnic-wear",
    isSample: true,
    swatches: ["#a86068", "#ead4c7"],
  },
  {
    id: 204,
    title: "DAINA Suit Set | Indigo Floral",
    images: [IMG_ETHNIC_IMAGE_4, IMG_ETHNIC_IMAGE_1],
    prices: { default: "Sample look" },
    color: "Indigo",
    category: "ethnic-wear",
    isSample: true,
    swatches: ["#3c4d69", "#f0e5d3"],
  },
];

// const jewelleryItems = [
//   {
//     id: 3,
//     title: "Feather Silver Necklace",
//     images: [
//       SilverNecklace1,
//       SilverNecklace2,
//       SilverNecklace3,
//       SilverNecklace4,
//       SilverNecklace5,
//       SilverNecklace6,
//     ],
//     prices: {
//       US: "$49.90",
//       CA: "CAD $69.90",
//       IN: "₹3,990.00",
//       default: "$49.99",
//     },
//     asin: "B0F7HSZ3GV",
//     category: "jewellery",
//     // shipping: "Free shipping worldwide",
//     description:
//       "Handcrafted feather silver necklace that symbolizes freedom and lightness. A perfect gift for your loved ones.",
//     details: [
//       "925 Sterling Silver",
//       "Handcrafted design",
//       "Hypoallergenic",
//       "Comes with gift box",
//       "Adjustable chain length",
//     ],
//   },
//   {
//     id: 4,
//     title: "Frost Silver Earrings",
//     images: [
//       SilverEarring1,
//       SilverEarring2,
//       SilverEarring3,
//       SilverEarring4,
//       SilverEarring5,
//       SilverEarring6,
//     ],
//     prices: {
//       US: "$39.90",
//       CA: "CAD $49.90",
//       IN: "₹2,990.00",
//       default: "$39.99",
//     },
//     asin: "B0F7LJ13DS",
//     category: "jewellery",
//     // shipping: "Free shipping worldwide",
//     description:
//       "Elegant frost silver earrings that catch the light beautifully. Perfect for both everyday wear and special occasions.",
//     details: [
//       "925 Sterling Silver",
//       "Lightweight design",
//       "Secure butterfly backs",
//       "Polished finish",
//       "Comes with gift pouch",
//     ],
//   },
// ];

// Custom arrow icons for carousel
const CustomLeftArrow = () => (
  <svg width="34" height="20" viewBox="0 0 34 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M32 10H2M2 10L11 1M2 10L11 19"
      stroke="currentColor"
      strokeWidth="1"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const CustomRightArrow = () => (
  <svg width="34" height="20" viewBox="0 0 34 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M2 10H32M32 10L23 1M32 10L23 19"
      stroke="currentColor"
      strokeWidth="1"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const Products = ({
  hoodieRef,
  jewelleryRef,
  userCountry,
  showOnlyHoodies = false,
  showOnlyTshirts = false,
  showAllProducts = false,
  fromCategory = false,
}) => {
  const navigate = useNavigate();
  const carouselRef = useRef(null);
  const [isBestsellersHovered, setIsBestsellersHovered] = useState(false);

  const scroll = (direction) => {
    if (carouselRef.current) {
      const scrollAmount = carouselRef.current.clientWidth;
      carouselRef.current.scrollBy({
        left: direction === "left" ? -scrollAmount : scrollAmount,
        behavior: "smooth",
      });
    }
  };

  const [subscribed, setSubscribed] = useState(false);
  const [subscriberEmail, setSubscriberEmail] = useState("");

  const [products, setProducts] = useState([]);
  const [tshirts, setTshirts] = useState(ethnicWearProducts);



  // Add scroll effect when component mounts and showOnlyHoodies is true
  useEffect(() => {
    if (showOnlyHoodies && hoodieRef.current && !fromCategory) {
      // Scroll to hoodies section when this route is accessed
      setTimeout(() => {
        window.scrollTo({
          top: hoodieRef.current.offsetTop - 100,
          behavior: "smooth",
        });
      }, 100);
    }
  }, [showOnlyHoodies, hoodieRef, fromCategory]);

  const handleCardClick = (product) => {
    const slug = product.title
      .toLowerCase()
      .replace(/\s*\|\s*/g, "-") // Only replace pipe characters with surrounding spaces
      .replace(/\s+/g, "-"); // Replace remaining spaces with hyphens

    navigate(`/product-description/${slug}`, {
      state: {
        product: product,
        country: userCountry,
      },
    });
  };

  const handlePreOrderClick = (product) => {
    const slug = product.title
      .toLowerCase()
      .replace(/\s*\|\s*/g, "-")
      .replace(/\s+/g, "-");

    navigate(`/pre-order/${slug}`, {
      state: {
        product: product,
        country: userCountry,
      },
    });
  };

  const getFormattedPrice = (product) => {
    if (!userCountry?.code) return product.prices.default;

    switch (userCountry.code) {
      case "IN":
        return product.prices.IN;
      case "US":
        return product.prices.US;
      case "CA":
        return product.prices.CA;
      default:
        return product.prices.default;
    }
  };

  return (
    <>
      {/* Add the main heading section - only show when showOnlyHoodies is true AND not from category page */}
      {showOnlyHoodies && !fromCategory && (
        <>
          <Box
            sx={{
              width: "100%",
              backgroundColor: "#fff",
              py: 3,
              mt: 18,
            }}
          >
            <Container maxWidth="lg">
            </Container>
          </Box>
        </>
      )}
      <Container disableGutters maxWidth={false} sx={{ mt: fromCategory ? 0 : { xs: 6, md: 8 }, mb: 4, px: 0 }}>
        {/* Hoodie Section */}
        <div ref={hoodieRef}>
          {/* Only show the small heading when NOT on a category page */}
          {!fromCategory && (
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "flex-end",
                px: { xs: 2, md: 4 },
                mb: 4,
              }}
            >
              <Typography
                variant="h4"
                sx={{ 
                  fontWeight: 500, 
                  color: "#000", 
                  fontSize: { xs: "20px", sm: "24px", md: "28px" }, 
                  fontFamily: '"Playfair Display", serif',
                  letterSpacing: '0.02em',
                  textTransform: 'none'
                }}
                id="tshirts-section"
              >
                Women's Ethnic Wear
              </Typography>
              <Typography
                component="a"
                href="/all-products"
                sx={{
                  color: "#000",
                  fontSize: { xs: "12px", md: "13px" },
                  fontWeight: 400,
                  textTransform: "uppercase",
                  pb: "1px",
                  borderBottom: "1.5px solid #000",
                  textDecoration: "none",
                  letterSpacing: { xs: "1px", md: "1.5px" },
                  whiteSpace: "nowrap",
                  fontFamily: '"Inter", sans-serif',
                  "&:hover": { color: "#666", borderBottom: "1.5px solid #666" },
                }}
              >
                SHOP ALL
              </Typography>
            </Box>
          )}
          {/* Carousel Container */}
          <Box
            onMouseEnter={() => setIsBestsellersHovered(true)}
            onMouseLeave={() => setIsBestsellersHovered(false)}
            sx={{ position: "relative", mx: 0 }}
          >
            {/* Left Arrow */}
            {!showOnlyHoodies && !showOnlyTshirts && !showAllProducts && (
              <IconButton
                onClick={() => scroll("left")}
                sx={{
                  position: "absolute",
                  left: isBestsellersHovered ? 0 : "-60px",
                  opacity: isBestsellersHovered ? 1 : 0,
                  top: "250px", // Align with image center
                  transform: "translateY(-50%)",
                  zIndex: 10,
                  backgroundColor: "#fff",
                  color: "#000",
                  borderRadius: 0,
                  width: "70px",
                  height: "45px",
                  boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
                  transition: "all 0.4s cubic-bezier(0.165, 0.84, 0.44, 1)",
                  "&:hover": {
                    backgroundColor: "#000",
                    color: "#fff"
                  },
                  display: { xs: "none", md: "flex" }
                }}
              >
                <CustomLeftArrow />
              </IconButton>
            )}

            {/* Right Arrow */}
            {!showOnlyHoodies && !showOnlyTshirts && !showAllProducts && (
              <IconButton
                onClick={() => scroll("right")}
                sx={{
                  position: "absolute",
                  right: isBestsellersHovered ? 0 : "-70px",
                  opacity: isBestsellersHovered ? 1 : 0,
                  top: "250px", // Align with image center
                  transform: "translateY(-50%)",
                  zIndex: 10,
                  backgroundColor: "#fff",
                  color: "#000",
                  borderRadius: 0,
                  width: "70px",
                  height: "45px",
                  boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
                  transition: "all 0.4s cubic-bezier(0.165, 0.84, 0.44, 1)",
                  "&:hover": {
                    backgroundColor: "#000",
                    color: "#fff"
                  },
                  display: { xs: "none", md: "flex" }
                }}
              >
                <CustomRightArrow />
              </IconButton>
            )}

            <Box
              ref={carouselRef}
              sx={{
                display: "flex",
                overflowX: "auto",
                scrollbarWidth: "none",
                "&::-webkit-scrollbar": { display: "none" },
                scrollSnapType: (showOnlyHoodies || showOnlyTshirts || showAllProducts || fromCategory) ? "none" : "x mandatory",
                gap: 0,
                px: 0,
                flexWrap: (showOnlyHoodies || showOnlyTshirts || showAllProducts || fromCategory) ? "wrap" : "nowrap"
              }}
            >
              {(() => {
                let productsToShow;
                if (showAllProducts) {
                  productsToShow = ethnicWearProducts;
                } else if (showOnlyHoodies) {
                  productsToShow = ethnicWearProducts;
                } else {
                  productsToShow = ethnicWearProducts;
                }
                return productsToShow.map((product) => {
                const [brand, ...rest] = product.title.split(" ");
                const restTitle = rest.join(" ").replace(/\|/g, "");
                return (
                  <Box
                    key={product.id}
                  sx={{
                      width: { 
                        xs: "50%", 
                        sm: "33.333%", 
                        md: (fromCategory || showOnlyHoodies || showOnlyTshirts || showAllProducts) ? "25%" : "calc(26.5% - 24px)" 
                      },
                      minWidth: { 
                        xs: "50%", 
                        sm: "33.333%", 
                        md: (fromCategory || showOnlyHoodies || showOnlyTshirts || showAllProducts) ? "25%" : "calc(26.5% - 24px)" 
                      },
                      scrollSnapAlign: "start",
                      mb: (showOnlyHoodies || showOnlyTshirts || showAllProducts) ? 4 : 0,
                      px: 0
                    }}
                  >
                    {/* Image Card */}
                    <Card
                      sx={{
                        borderRadius: "0px",
                        boxShadow: "none",
                        position: "relative",
                        overflow: "hidden",
                        "&:hover": {
                          cursor: product.isSample ? "default" : "pointer",
                        },
                        "&:hover .quick-buy-btn": {
                          transform: product.isSample ? "translateY(100%)" : "translateY(0)",
                        }
                      }}
                      onClick={() => {
                        if (product.isSample) return;
                        handleCardClick(product);
                      }}
                    >
                      <ImageSlider images={product.images} />

                      {/* QUICK BUY Button */}
                      <Box
                        className="quick-buy-btn"
                        sx={{
                          position: "absolute",
                          bottom: 0,
                          left: 0,
                          width: "100%",
                          backgroundColor: "#000",
                          color: "#fff",
                          textAlign: "center",
                          py: 1.5,
                          fontSize: "12px",
                          fontWeight: 500,
                          letterSpacing: "0.1em",
                          textTransform: "uppercase",
                          transform: "translateY(100%)",
                          transition: "transform 0.4s cubic-bezier(0.165, 0.84, 0.44, 1)",
                          zIndex: 11,
                          display: product.isSample ? "none" : "block",
                        }}
                      >
                        QUICK BUY
                      </Box>

                      {product.isSample && (
                        <Box
                          sx={{
                            position: "absolute",
                            top: 12,
                            left: 12,
                            px: 1.25,
                            py: 0.75,
                            backgroundColor: "rgba(255,255,255,0.92)",
                            color: "#222",
                            fontSize: "10px",
                            fontWeight: 600,
                            letterSpacing: "0.08em",
                            textTransform: "uppercase",
                            zIndex: 10,
                          }}
                        >
                          Sample look · Not for sale
                        </Box>
                      )}

                      {product.isSoldOut && (
                        <Box
                          sx={{
                            position: "absolute",
                            top: "50%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                            backgroundColor: "#ff0000d1",
                            color: "white",
                            letterSpacing: "0.1em",
                            fontSize: "14px",
                            px: 2.5,
                            py: 1,
                            zIndex: 10,
                            textTransform: "uppercase",
                          }}
                        >
                          SOLD OUT
                        </Box>
                      )}
                      {(product.category === "hoodie" || product.category === "sweatshirt") && (
                        <Box
                          sx={{
                            position: "absolute",
                            bottom: 12,
                            left: "50%",
                            transform: "translateX(-50%)",
                            backgroundColor: "rgba(0,0,0,0.72)",
                            color: "#fff",
                            letterSpacing: "0.12em",
                            fontSize: "11px",
                            fontWeight: 500,
                            px: 2,
                            py: 0.7,
                            zIndex: 10,
                            textTransform: "uppercase",
                            whiteSpace: "nowrap",
                          }}
                        >
                          Coming in Winter
                        </Box>
                      )}
                    </Card>

                    {/* Product Info */}
                    <Box sx={{ mt: 1.5 }}>
                      <Typography
                        sx={{
                          fontSize: "14px",
                          fontWeight: 500,
                          display: "flex",
                          flexWrap: "wrap",
                          alignItems: "center",
                          lineHeight: 1.3,
                          mb: 0.5,
                          px: 1.5,
                          fontFamily: '"Inter", sans-serif',
                        }}
                      >
                        {/* Brand */}
                        <Box
                          component="span"
                          sx={{
                            fontFamily: '"Playfair Display", serif',
                            mr: { xs: 0, md: 0.5 },
                            mb: { xs: 0.5, md: 0 },
                            letterSpacing: "0.5px",
                          }}
                        >
                          {brand}
                        </Box>

                        {/* Product */}
                        <Box
                          component="span"
                          sx={{
                            color: "#333",
                          }}
                        >
                          {restTitle}
                        </Box>
                      </Typography>

                      {/* Price, Swatches and Cart Row */}
                      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', px: 1.5, pb: 3 }}>
                        <Box>
                          <Typography
                            sx={{
                              fontSize: "13px",
                              color: "#000",
                              fontWeight: 400,
                              mb: 1.5,
                              fontFamily: '"Inter", sans-serif',
                            }}
                          >
                            {product.isSample ? product.prices.default : getFormattedPrice(product)}
                          </Typography>
                          
                          {/* Color Swatches */}
                          <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
                            {product.swatches?.map((color, index) => (
                              <Box
                                key={index}
                                sx={{
                                  width: 14,
                                  height: 14,
                                  borderRadius: '50%',
                                  backgroundColor: color,
                                  p: index === 0 ? '2px' : 0, // Inset feel for active
                                  backgroundClip: 'content-box',
                                  cursor: 'pointer'
                                }}
                              />
                            ))}
                          </Box>
                        </Box>
                      </Box>
                    </Box>
                  </Box>
                );
                });
              })()}
            </Box>
          </Box>
        </div>


        {/* Featured Edits Section */}
        {!fromCategory && <FeaturedEdits />}

        {/* Shop The Look Section */}
        {!fromCategory && <ShopTheLook />}
        {/* Jewellery Section */}
        {/* <div ref={jewelleryRef}>
          <Typography
            variant="h4"
            align="center"
            sx={{ fontWeight: "bold", mb: 4, color: "#333", mt: 8 }}
            id="jewellery-section"
          >
            Premium Silver Jewellery
          </Typography>
          <Grid container spacing={4}>
            {jewelleryItems.map((item) => (
              <Grid item xs={12} sm={6} md={4} key={item.id}>
                <Card
                  sx={{
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",
                    borderRadius: "8px",
                    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                    transition: "transform 0.3s ease-in-out",
                    "&:hover": {
                      transform: "scale(1.03)",
                      cursor: "pointer",
                    },
                  }}
                  onClick={() => handleCardClick(item)}
                >
                  <ImageSlider images={item.images} />
                  <CardContent sx={{ flexGrow: 1 }}>
                    <Typography
                      gutterBottom
                      variant="h6"
                      component="div"
                      sx={{ color: "grey" }}
                    >
                      {item.title}
                    </Typography>
                    <Typography variant="h6" sx={{ fontWeight: "bold" }}>
                      {getFormattedPrice(item)}
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
            ))}
            <Grid item xs={12} sm={6} md={4}>
              <Box
                sx={{
                  marginTop: "48px",
                  display: "flex",
                  position: "relative",
                  borderRadius: "8px",
                  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                  overflow: "hidden",
                }}
              >
                <CardMedia
                  component="img"
                  image={SideImage2}
                  alt="Daina Jewellery Model"
                  sx={{
                    height: "540px",
                    width: "100%",
                    objectFit: "cover",
                  }}
                />
                <Box
                  sx={{
                    position: "absolute",
                    top: 0,
                    bottom: 0,
                    left: 0,
                    right: 0,
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    textAlign: "center",
                    background:
                      "linear-gradient(to top, rgba(0,0,0,0.8) 0%, transparent 50%, transparent 100%)",
                    color: "#f1f1f1",
                    padding: "40px",
                  }}
                >
                  <Typography
                    variant="h4"
                    component="div"
                    sx={{
                      fontWeight: 500,
                      fontFamily: "Raleway, sans-serif",
                      mb: 2,
                      color: "#fff",
                      maxWidth: "100%",
                    }}
                  >
                    From us, all the way to you
                  </Typography>
                  <Typography
                    variant="body1"
                    sx={{
                      maxWidth: "100%",
                    }}
                  >
                    From the far North we pack and ship our jewelry to customers
                    all over the world.
                  </Typography>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </div> */}
        {fromCategory && !showOnlyTshirts && (
          <Box sx={{ width: "100%", textAlign: "center", mt: 8, mb: 2 }}>
            <Typography sx={{ fontSize: "11px", letterSpacing: "1px", fontWeight: 700, color: "#333" }}>
              SHOWING {ethnicWearProducts.length} OUT OF {ethnicWearProducts.length}
            </Typography>
          </Box>
        )}
      </Container>
      {/*<Reviews />*/}
      {!fromCategory && !showOnlyTshirts && <Box sx={{ width: "100%", position: "relative" }}>
        <CardMedia
          component="img"
          image={IMG_ETHNIC_IMAGE_4}
          alt="Daina Collection"
          sx={{
            width: "100%",
            height: "auto",
            maxHeight: { xs: "300px", sm: "400px", md: "600px" },
            objectFit: "cover",
          }}
        />
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            textAlign: "center",
            color: "#f1f1f1",
            width: "100%",
            px: { xs: 2, sm: 3, md: 4 },
          }}
        >
          <Typography
            variant="h3"
            component="div"
            sx={{
              fontWeight: 500,
              mb: 1,
              color: "#fff",
              fontSize: {
                xs: "1.6rem", // Mobile
                sm: "2.2rem", // Tablet
                md: "2.8rem", // Desktop
              },
            }}
          >
            DISCOVER OUR COLLECTION
          </Typography>
          <Typography
            variant="h6"
            sx={{
              fontSize: {
                xs: "0.6rem", // Mobile
                sm: "1rem", // Tablet
                md: "1.2rem", // Desktop
              },
            }}
          >
            QUALITY CRAFTSMANSHIP MEETS TIMELESS
          </Typography>
        </Box>
      </Box>}
      {!fromCategory && !showOnlyTshirts && <Box
        sx={{
          width: "100%",
          backgroundColor: "#f3f3f3",
          py: { xs: 6, md: 8 },
        }}
      >
        <Box
          sx={{
            maxWidth: "1200px",
            mx: "auto",
            textAlign: "center",
            px: 2,
          }}
        >
          <Typography
            sx={{
              fontSize: { xs: "1.6rem", md: "2rem" },
              fontWeight: 400,
              mb: 2,
              letterSpacing: "0.03em",
            }}
          >
            Join the{" "}
            <Box component="span" sx={{ fontFamily: "serif", fontSize: "2.2rem" }}>
              DAINA
            </Box>{" "}
            Community
          </Typography>

          <Typography
            sx={{
              fontSize: "0.95rem",
              color: "#555",
              maxWidth: "600px",
              mx: "auto",
              mb: 4,
            }}
          >
            Subscribe now and be first to hear about new products and discounts from Daina.
          </Typography>

          {/* Email Form */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              maxWidth: "650px",
              mx: "auto",
            }}
          >
            {subscribed ? (
              <Typography
                sx={{
                  fontSize: "1rem",
                  color: "#000",
                }}
              >
                Thanks for subscribing
              </Typography>
            ) : (
              <Box
                component="form"
                sx={{
                  display: "flex",
                  width: "100%",
                }}
                onSubmit={async (e) => {
                  e.preventDefault();
                  try {
                    await axios.post('/api/email/subscribe-confirm', { email: subscriberEmail });
                    setSubscribed(true);
                  } catch (err) {
                    console.error('Subscription error:', err);
                    setSubscribed(true); // Still show thanks message
                  }
                }}
              >
                <TextField
                  placeholder="Enter your email"
                  variant="outlined"
                  fullWidth
                  value={subscriberEmail}
                  onChange={(e) => setSubscriberEmail(e.target.value)}
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      borderRadius: 0,
                      backgroundColor: "#fff",

                      "& .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#ddd",
                      },

                      "&:hover .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#ddd",
                      },

                      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#ddd !important",
                      },
                    },

                    "& input::placeholder": {
                      color: "#888",
                      opacity: 1,
                    },
                  }}
                  InputProps={{
                    sx: {
                      height: "44px",
                    },
                  }}
                />

                <Button
                  type="submit"
                  variant="contained"
                  sx={{
                    ml: "-1px",
                    backgroundColor: "#000",
                    color: "#fff",
                    borderRadius: 0,
                    px: 2.5,
                    height: "44px",
                    fontSize: "0.75rem",
                    letterSpacing: "0.12em",
                    whiteSpace: "nowrap",
                    minWidth: "fit-content",
                    boxShadow: "none",
                    "&:hover": {
                      backgroundColor: "#000",
                      boxShadow: "none",
                    },
                  }}
                >
                  <Box
                    component="span"
                    sx={{
                      position: "relative",
                      display: "inline-block",

                      "&::after": {
                        content: '""',
                        position: "absolute",
                        left: 0,
                        bottom: "-2px",
                        width: "0%",
                        height: "1px",
                        backgroundColor: "#fff",
                        transition: "width 0.35s ease",
                      },

                      ".MuiButton-root:hover &::after": {
                        width: "100%",
                      },
                    }}
                  >
                    SIGN UP NOW
                  </Box>
                </Button>
              </Box>
            )}
          </Box>

          <Typography
            sx={{
              mt: 3,
              fontSize: "0.7rem",
              color: "#777",
              maxWidth: "620px",
              mx: "auto",
              lineHeight: 1.6,
            }}
          >
            I can revoke my consent at any time by contacting Daina and
            unsubscribing from the newsletter. For further details, please see the{" "}
            <Box
              component="span"
              sx={{
                textDecoration: "underline",
                cursor: "pointer",
              }}
            >
              <Link
                href="/privacy"
                sx={{
                  textDecoration: "underline",
                  cursor: "pointer",
                  color: "#777",
                  "&:visited": {
                    color: "#777",
                  },
                  "&:hover": {
                    color: "#777",
                  },
                }}
              >
                privacy policy
              </Link>
            </Box>.
          </Typography>
        </Box>
      </Box>}
    </>
  );
};

export default Products;
